import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { Context } from 'src/app/controls/advanced-gridview/models/context';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from 'src/app/controls/advanced-gridview/services/advanced-service';
import { CrudFormComponent } from 'src/app/controls/crud-form/crud-form.component';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { Box } from 'src/app/models/box';
import { Rights } from 'src/app/models/enums/rights';
import { IBoxGroup } from 'src/app/models/interfaces/box-group.interface';
import { BoxesService } from 'src/app/services/boxes.service';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { AdvancedGridviewComponent } from '../../../controls/advanced-gridview/advanced-gridview.component';
import { BoxFormDialogComponent } from './box-form-dialog/box-form-dialog.component';

// @Component({
//   selector: 'app-boxes-form',
//   templateUrl: './boxes-form.component.html',
//   styleUrls: ['./boxes-form.component.scss']
// })
// export class BoxesFormComponent extends DefaultHttpService implements OnInit {
//   public faFileExport = faFileExport;
//   public faSave = faSave;
//   public faFileimport = faFileImport;

//   /** Pour être utilisable dans le template */
//   FormMode: any = FormMode;
//   recordFactory = new BoxesFactory();

//   /**
//   * Reference au composant AdvancedGridview.
//   */
//   @ViewChild(EditableTableComponent) editableTable: EditableTableComponent;

//   // Accès au enfant de type fileToUpload
//   @ViewChild('fileToUpload', { static: true }) fileToUploadVariable: ElementRef;

//   // Composant FileUploaderCustom
//   public uploader: FileUploader = null;

//   /**
//     * Infos du client à afficher dans le formulaire.
//     */
//   // eslint-disable-next-line @angular-eslint/no-input-rename
//   @Input('boxGroup')
//   public dataInput: Required<IBoxGroup> | null | undefined;

//   /**
//   * Contexte du formulaire (mode d'affichage ...).
//   */
//   public _context: BoxGroupFormContext = null;

//   /**
//   * Utilisé pour propager des changements de contexte.
//   */
//   public _context$: BehaviorSubject<BoxGroupFormContext> = new BehaviorSubject(null);

//   /**Indique si le tableau est valid */
//   public isValid: boolean = true;

//   /**
//     * Appellé par le composant parent pour specifier un nouveau contexte.
//     */
//   @Input()
//   set context(value: BoxGroupFormContext) {
//     this._context$.next(value);
//   }

//   @Output()
//   public boxesUpdated: EventEmitter<IBoxGroup> = new EventEmitter();

//   /**
//    * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
//    */
//   @Output()
//   public canceled: EventEmitter<boolean> = new EventEmitter();

//   /**
//   * Gestion des model d'une bannette
//   */
//   boxTableModel: InlineEditableTableModel<Box>;
//   boxDataSource: BatchInlineEditableDataSource<Box>;
//   boxTableConfig: EditableColumnDefinition<Box>[] = [
//     new EditableColumnDefinition<Box>('name', 'Nom', ColumnType.Text, FilterType.Text, 2, true, true, true),
//     new EditableColumnDefinition<Box>('order', 'Ordre', ColumnType.Numeric, FilterType.Numeric, 5, true, true, true)];
//   boxRights: IEditableRightInterface = { Create: false, Edit: false, Delete: false };

//   /**
//    * Constructeur
//    */
//   constructor(private boxesService: BoxesService, public enumHelper: EnumHelper, public memoryService: MemoryService) {
//     super(memoryService);

// 	// Specifie des colonnes en fonction des droits utilisateurs
// 	this.boxTableConfig.splice(0, 0, new EditableColumnDefinition<Box>('id', 'Id', ColumnType.Text, FilterType.Text, 1, this.memoryService.getConnectedUser().params.idVisible === true, false));

//     if (!!this.memoryService.getConnectedUser().hasRight(Rights.BoxCreate)) {
//       this.boxRights.Create = true;
//     }
//     if (!!this.memoryService.getConnectedUser().hasRight(Rights.BoxEdit)) {
//       this.boxRights.Edit = true;
//     }
//     if (!!this.memoryService.getConnectedUser().hasRight(Rights.BoxDelete)) {
//       this.boxRights.Delete = true;
//     }
//   }

//   ngOnInit(): void {
//     // S'abonne aux changements de contexte
//     this._context$ .subscribe(x => {
//       let newContext = x;
//       if (newContext === null || newContext === undefined) {
//         // do nothing
//       } else if (this._context === null || this._context.boxGroup.id !== newContext.boxGroup.id) {
//         this._context = newContext;

//         if (this._context.boxGroup) {
//           let datasourceContext: Context = { property: '', value: newContext.boxGroup.id };
//           this.boxDataSource = new BatchInlineEditableDataSource(datasourceContext, this.boxesService);
//           this.boxTableModel = new InlineEditableTableModel(this.boxTableConfig, 'id', true, new SortInfos('order', 'asc'));
//         }

//         if (!!this.editableTable) {
//           this.editableTable.reset();
//         }

//       } else {
//         this._context = newContext;
//         this.boxDataSource.reloadRecords();
//       }
//     });

//     this.uploader = new FileUploader({
//       url: `${this.baseUrl}/api/organizations/${this.organizationId}/boxgroups/${this._context.boxGroup.id}/boxes/import`,
//       authTokenHeader: 'Authorization',
//       authToken: `Bearer ${this.connectedUser.token.accessToken}`,
//       allowedFileType: ["xls"],
//       queueLimit: 1,
//     });

//     this.uploader.onAfterAddingFile = (fileItem) => {
//       fileItem.withCredentials = false;
//     };

//     this.uploader.onCompleteAll = () => {
//       this.editableTable.reloadMessages();
//     };
//   }

//   public onFileSelected () {
//     this.uploader.uploadAll();
//   }

//   /** Recupération de la valeur de validité du formulaire */
//   public onIsValid(isValid: boolean) {
//     this.isValid = isValid;
//   }

//   applyBox() {
// 	if (this.isValid) {
// 		this.boxDataSource.applyBatchModifications();
// 		this.boxesUpdated.emit(this._context.boxGroup);
// 	}
//   }

//   public onBoxesExported() {
//     this.boxDataSource.export(`Bannettes du groupe ${this._context.boxGroup.id}`);
//   }

//   public cancel(): void {
// 	  this.canceled.emit(true);
//   }
// }

@Component({
    selector: 'app-boxes-form',
    templateUrl: '../../../controls/crud-form/crud-form.component.html',
    styleUrls: ['../../../controls/crud-form/crud-form.component.scss'],
    imports: [AdvancedGridviewComponent, MatButtonModule, FileUploadModule, NgxSpinnerModule],
})
export class BoxesFormComponent extends CrudFormComponent<Box, IBoxGroup, BoxFormDialogComponent> {
    /**
     * Constructeur.
     * @param enumHelper: Classe utilitaire pour les énumérations.
     * @param notificationService: Service utilisé pour gérer l'affichage des notifications.
     * @param spinner: Service utilisé pour gérer l'affichage du spinner.
     * @param dialog: Service pour ouvrir des boites de dialogue.
     * @param memoryService: Service pour récupérer les informations en mémoire.
     */
    public constructor(
        private boxesService: BoxesService,
        public override enumHelper: EnumHelper,
        protected override notificationService: NotificationService,
        protected override spinner: NgxSpinnerService,
        public override dialog: MatDialog,
        public override memoryService: MemoryService
    ) {
        super(enumHelper, notificationService, spinner, dialog, memoryService);
    }

    /**
     * Définition des colonnes de la Gridview.
     */
    override get defaultTableConfig(): ColumnDefinition[] {
        return [
            new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 85, true),
            new ColumnDefinition('order', 'Ordre', ColumnType.Text, FilterType.Text, 3, 10, true),
        ];
    }

    /**
     * Définition des colonnes de la Gridview.
     */
    override get withIdTableConfig(): ColumnDefinition[] {
        return [
            new ColumnDefinition('id', 'Id', ColumnType.Text, FilterType.Text, 1, 15, true),
            new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 70, true),
            new ColumnDefinition('order', 'Ordre', ColumnType.Text, FilterType.Text, 3, 10, true),
        ];
    }

    /**
     * Instancie un nouvel enregistrement.
     */
    protected override instantiateNewRecord(): Box {
        let record = new Box();
        record.groupId = this._context.item.id;
        record.viewId = this.memoryService.getSelectedView().id;
        return record;
    }

    /**
     * Retourne le texte de confirmation de la suppression.
     */
    protected override getDeleteConfirmationText(item: Box): string {
        return `Vous êtes sur le point de supprimer la bannette '${item.id}'.`;
    }

    /**
     * Retourne le texte de suppression.
     */
    protected override getDeletionText(): string {
        return 'Bannette supprimée';
    }

    /**
     * Retourne le texte d'erreur de suppression.
     */
    protected override getDeletionErrorText(): string {
        return 'Impossible de supprimer la bannette.';
    }

    /**
     * Retourne le texte de création.
     */
    protected override getCreationText(): string {
        return 'Bannette créée';
    }

    /**
     * Retourne le texte d'erreur de création.
     */
    protected override getCreationErrorText(): string {
        return 'Impossible de créer la bannette.';
    }

    /**
     * Retourne le texte de mise à jour.
     */
    protected override getUpdateText(): string {
        return 'Bannette mise à jour';
    }

    /**
     * Retourne le texte d'erreur de mise à jour.
     */
    protected override getUpdateErrorText(): string {
        return 'Impossible de mettre à jour la bannette.';
    }

    /**
     * Retourne la requête pour supprimer un enregistrement.
     * @param item : Instance de l'enregistrement à supprimer.
     */
    protected override getDeletionRequest(item: Box): Observable<boolean> {
        return this.boxesService.delete(item.id);
    }

    /**
     * Retourne la requête pour créer un enregistrement.
     * @param item : Instance de l'enregistrement à créer.
     */
    protected override getCreationRequest(item: Box): Observable<Box> {
        return this.boxesService.add(item);
    }

    /**
     * Retourne la requête pour mettre à jour un enregistrement.
     * @param item : Instance de l'enregistrement à mettre à jour.
     */
    protected override getUpdateRequest(item: Box): Observable<Box> {
        return this.boxesService.update(item.id, item);
    }

    /**
     * Retourne la requête pour uploader le fichier d'import.
     */
    protected override getUploadRequest(): string {
        return `${this.baseUrl}/api/organizations/${this.organizationId}/views/${this.viewId}/boxes/import`;
    }

    /**
     * Retourne le composant boite de dialogue utilisé pour afficher le formulaire de création / édition / consultation.
     */
    protected override getDialogComponent(): new (...args: any[]) => BoxFormDialogComponent {
        return BoxFormDialogComponent;
    }

    /**
     * Retourne le nom du fichier d'export.
     */
    protected override getExportFileName(): string {
        return `Bannettes du groupe ${this._context.item.id}.xlsx`;
    }

    /**
     * Retourne le duplicata d'un enregistrement.
     * @param item : Instance de l'enregistrement à dupliquer.
     */
    protected override duplicate(item: Box): Box {
        let record = new Box();
        record.groupId = item.groupId;
        record.name = item.name;
        record.order = item.order;
        record.viewId = item.viewId;
        return record;
    }

    /**
     * Retourne la source de données de la liste.
     */
    protected override getDatasourceService(): AdvancedService<Box> {
        return this.boxesService;
    }

    /**
     * Retourne le contexte utilisé par la source de données de la liste.
     */
    protected override getDatasourceContext(): Context {
        return { property: '', value: this._context.item.id };
    }

    /**
     * Retourne les infos de tri par défaut de la liste.
     */
    protected override getDefaultSortInfos(): SortInfos {
        return new SortInfos('name', 'asc');
    }

    /**
     * Retourne le droit necessaire pour pouvoir crééer un enregistrement.
     */
    public override getCreationRight(): Rights {
        return Rights.BoxCreate;
    }

    /**
     * Retourne le droit necessaire pour pouvoir mettre à jour un enregistrement.
     */
    protected override getUpdateRight(): Rights {
        return Rights.BoxEdit;
    }

    /**
     * Retourne le droit necessaire pour pouvoir supprimer un enregistrement.
     */
    protected override getDeletionRight(): Rights {
        return Rights.BoxDelete;
    }
}
